module.exports = __webpack_public_path__ + "static/media/01.198a0208.png";